import { shallowMount } from "@vue/test-utils";
import FloatingTip from "@/components/core/custom/FloatingTip";

describe("FloatingTip component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(FloatingTip);
  });

  it("Renders del component FloatingTip", () => {
    expect(wrapper).toBeDefined();
  });
});
